// Tekst die eruitziet als een ingevuld veld maar dat niet is.
//
// 'undefined', 'null', 'nan' en 'none' bereiken Firestore als gewone tekst —
// via een URL-segment, een externe koppeling, een `${x}`-interpolatie of een
// geleegd invoerveld. Ze zijn allemaal truthy, dus ze passeren élke
// `x || ''`-controle zonder fout en zonder waarschuwing.
// AI-CONTEXT: See docs/pitfalls.md#database-url-sentinel-string-persisted
//
// WAAROM ÉÉN LIJST. Er stonden zes losse kopieën in `src/`, en ze liepen uiteen:
// de een kende 'none', de ander niet; de een nam '' mee, de ander niet;
// `registrationDate` vergeleek op 'NaN' mét hoofdletters terwijl de rest
// lowercase vergeleek. Dat verschil was drift, geen ontwerp — welke schrijfwijze
// binnenkomt hangt van de bron af, niet van de plek die hem leest.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
//
// DE LIJST IS DE VERENIGING, NIET DE DOORSNEDE. Wat op één plek geen waarde was,
// is dat nergens. Nagelopen per plek: elk van de vier oude lijsten kwam met deze
// lijst op dezelfde uitkomst uit, omdat de niet-gedeelde woorden verderop
// alsnog sneuvelden (`Number('none')` is NaN, `new Date('none')` is ongeldig).
// De uitzondering staat bij `normalizePersonaParam` toegelicht.
//
// Gespiegeld in functions/utils/sentinelValue.js — wijzig BEIDE.
// De pariteit is gepind door functions/utils/sentinelValue.test.js, niet door
// dit commentaar. AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment

/**
 * Alles lowercase: de vergelijking is hoofdletterongevoelig.
 * @type {Set<string>}
 */
const SENTINELS = new Set(['', 'undefined', 'null', 'nan', 'none'])

/**
 * Schoont een waarde op tot de tekst die er werkelijk staat.
 *
 * Coerceert bewust in plaats van niet-strings af te wijzen: een BAG-id dat ooit
 * als getal is weggeschreven is net zo geldig, alleen de vorm verschilt. Wie
 * niet-strings wél wil weigeren, guardt op `typeof` vóór de aanroep — zie
 * `resolveProgrammes`.
 *
 * @param {*} value - Rauwe waarde uit Firestore, een URL-segment of een formulier
 * @returns {string} De getrimde tekst, of '' als er geen waarde staat
 */
const sentinelToEmpty = (value) => {
    if (value === null || value === undefined) return ''
    const text = String(value).trim()
    return SENTINELS.has(text.toLowerCase()) ? '' : text
}

/**
 * @param {*} value
 * @returns {boolean} Of er geen bruikbare waarde staat
 */
const isSentinel = (value) => sentinelToEmpty(value) === ''

export default sentinelToEmpty
export { sentinelToEmpty, isSentinel, SENTINELS }
